import classes from 'classnames';
import React, { ReactNode, useLayoutEffect, useRef } from 'react';
import styles from './Collapsible.module.scss';

export type CollapsibleProps = {
  expand?: boolean;
  children: ReactNode;
};

export default function Collapsible({ children, expand }: CollapsibleProps) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (expand && ref.current) {
      ref.current.style.height = `${ref.current.scrollHeight + 25}px`;
    } else if (!expand && ref.current) {
      ref.current.style.height = '0px';
    }
  }, [expand]);

  return (
    <div
      data-test="collapsible"
      className={classes(styles.container, expand && styles.expanded)}
      ref={ref}
    >
      {children}
    </div>
  );
}
